export default __webpack_public_path__ + "static/media/1214.a955f321.png";